import React from 'react';
import PropTypes from 'prop-types';
import { Form, FormBody, Button, FormFooter } from '@zen-common/components-base';
import { WalletStore } from '@zen/common-app-parts';
import { useNavigation } from 'react-navi';
import { DexSearchStore } from '@zen-dex/utils';
import { getRedirectTo } from '../../../../../../utils/redirectsUtils';
import PATHS from '../../../../../../paths';
import PriceQuantityTotalFormBody from './PriceQuantityTotalFormBody';

/**
 * Renders the price-quantity-total form
 * Should get props from usePriceQuantityTotal hook
 *
 * To be used as a normal form for MAKE
 */
export default function PriceQuantityTotalMakeForm({
  price,
  quantity,
  total,
  limitError,
  onPriceChange,
  onQuantityChange,
  onTotalChange,
  validation,
  onSubmit,
  submitText,
  available,
  isBuy,
}) {
  const navigation = useNavigation();
  const {
    state: { isLoggedIn, hasPassword },
  } = WalletStore.useStore();
  const { state: searchState } = DexSearchStore.useStore();
  const { base, quote } = searchState;

  const shouldDisplayLogin = hasPassword && !isLoggedIn;

  const handleSubmit = (e) => {
    e.preventDefault();

    if (shouldDisplayLogin || !hasPassword) {
      navigation.navigate(
        getRedirectTo({
          base,
          quote,
          path: hasPassword && !isLoggedIn ? PATHS.UNLOCK : PATHS.ONBOARDING,
        })
      );
    } else {
      if (typeof onSubmit === 'function' && validation.valid) {
        onSubmit();
      }
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormBody>
        <PriceQuantityTotalFormBody
          limitError={limitError}
          onPriceChange={onPriceChange}
          onQuantityChange={onQuantityChange}
          onTotalChange={onTotalChange}
          price={price}
          quantity={quantity}
          total={total}
          validation={validation}
          forceReadOnly={shouldDisplayLogin || !hasPassword}
          available={available}
          isBuy={isBuy}
        />
        <FormFooter>
          <Button
            type="submit"
            width="100%"
            bg="primary"
            disabled={!validation.valid && !shouldDisplayLogin && hasPassword}
          >
            {!hasPassword ? 'Connect a Wallet' : shouldDisplayLogin ? 'Login' : submitText}
          </Button>
        </FormFooter>
      </FormBody>
    </Form>
  );
}
PriceQuantityTotalMakeForm.propTypes = {
  price: PropTypes.object,
  quantity: PropTypes.object,
  total: PropTypes.object,
  limitError: PropTypes.any,
  onPriceChange: PropTypes.func,
  onQuantityChange: PropTypes.func,
  onTotalChange: PropTypes.func,
  validation: PropTypes.object,
  submitText: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
};
